<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div class="flex-between">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="砍价状态：" prop="orderStatus">
              <el-select v-model="searchForm.orderStatus" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in orderStatusArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品搜索：" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入拼团商品" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="结束时间：" prop="date">
              <el-date-picker
                v-model="searchForm.date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="orderNo"
            label="订单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="砍价开始时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="砍价商品">
          </el-table-column>
          <el-table-column
            align="center"
            prop="lowestMoneyBargain"
            label="最低价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsSpecPrice"
            label="当前价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.status == 1 ? '砍价成功' : scope.row.status == 2 ? '砍价失败' : '砍价中'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="bargainSuccessTime"
            label="结束时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="detailOpenBtn(scope.row.id)" type="text" size="small">砍价记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 砍价订单记录弹窗 -->
    <el-dialog
      title="砍价记录"
      :visible.sync="detailShow"
      width="960px">
      <el-table
        border
        :data="detailList">
        <el-table-column
          align="center"
          prop="headPicture"
          label="用户头像">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
              :preview-src-list="[scope.row.headPicture]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickName"
          label="用户昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="用户手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="userBargainMoney"
          label="砍价金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="砍价时间">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { queryBargainOrderLogPageList, queryUserBargainLogList } from '@/api/bargainActivity'
export default {
  name: 'BargainOrder',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: '',
        orderStatus: '',
        date: ['', '']
      },
      orderStatusArr: [{
        label:'砍价中',
        value:0
      },{
        label:'砍价成功',
        value:1
      },{
        label:'砍价失败',
        value:2
      }],
      // 砍价订单记录弹窗
      detailShow:false,
      detailList:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 砍价订单记录弹窗-打开弹窗操作
    detailOpenBtn(parentId){
      var that = this;
      queryUserBargainLogList({bargainOrderId:parentId}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            that.detailList = data;
            that.detailShow = true;
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let orderStatus = that.searchForm.orderStatus
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let page = that.currentPage
      queryBargainOrderLogPageList({ goodsName: searchName,status:orderStatus,startBargainSuccessDate:startDate,endBargainSuccessDate:endDate,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/bargainActivity/BargainOrder.vue